import { graphql } from "react-relay";
import {
  EventSummaryAttendees,
  EventSummaryExternalAttendees,
  EventSummaryRecurrence,
  EventSummaryTime,
  EventSummaryBestTimeRecurrence,
  EventSummaryRoom,
  EventSummaryAutopilotFlex,
} from "@components/event-summary";
import "@components/autopilot-flexibility/AutopilotFlexibility.gql";

export const fragments = {
  org: graphql`
    fragment OnboardingAutopilotEvent_org on Org {
      id
      domains
      experiments
      ...EventSummaryAttendees_org
      ...EventSummaryExternalAttendees_org
      ...EventSummaryRecurrence_org
      ...EventSummaryTime_org
      ...AutopilotFlexibility_org
    }
  `,
  event: graphql`
    fragment OnboardingAutopilotEvent_event on Event {
      ...EventSummaryRecurrence_event
      ...EventSummaryTime_event
      ...EventSummaryBestTimeRecurrence_event
      ...EventSummaryAutopilotFlex_event
      ...AutopilotFlexibility_event
      isClockwiseEvent
      calendarIds
      eventKey {
        id
        calendarIds
        externalEventId
        hashedCalendars
        orgId
      }
      organizerPerson {
        ... on Person {
          isYou
          primaryEmail
        }
      }
      attendees {
        ...EventSummaryAttendees_attendees
        ...EventSummaryExternalAttendees_attendees
        ...EventSummaryRoom_attendees
        displayName
        profileId
        optional
        organizer
        resource
        responseStatus
        urnType
        urnValue
      }
      creator {
        displayName
        profileId
        optional
        organizer
        resource
        responseStatus
        urnType
        urnValue
      }
      endTime {
        millis
        timeZone
        offsetMinutes
      }
      organizer {
        displayName
        profileId
        optional
        organizer
        resource
        responseStatus
        urnType
        urnValue
      }
      recurringEventId
      recurrenceRules {
        firstInstanceStartTime {
          timeZone
          offsetMinutes
        }
        timeZone
        interval {
          byDay
          count
        }
        cancelledInstances
      }
      startTime {
        millis
        timeZone
        offsetMinutes
      }
      title
      transparency
      isAllDay
      guestsCanInviteOthers
      guestsCanModify
      guestsCanSeeOtherGuests
      locked
      privateCopy
      description
      location
      etag
      htmlLink
      hangoutLink
      annotatedEvent {
        id
        externalEventId
        orgTags {
          tag
          state {
            lastModified
            subjectType
            subjectValue
            active
            value
          }
        }
        userTags {
          tag
          count
          states {
            lastModified
            subjectType
            subjectValue
            active
            value
          }
        }
      }
      createdMillis
      featureStatesForOrganizer {
        __typename
        ... on FeatureStates {
          mixedFreemiumOrgUIState {
            autopilotPaused
            moveRangesEnabled
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
